{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "claimType": {
          "cashOption": {
            "long": {
              "description": "Viivästys yli 4 tuntia, kun lento on yli 3 500 km ja lähtö- tai määränpää on EU:n ulkopuolella<br>Lentojen peruutus, kun lento on yli 3 500 km, lähtö- tai määränpää on EU:n ulkopuolella ja viivästys yli 4 tuntia",
              "title": "Käteisarvo 600 €"
            },
            "longHalf": {
              "description": "Viivästys 3–4 tuntia, kun lento on yli 3 500 km ja lähtö- tai määränpää on EU:n ulkopuolella<br>Lentojen peruutus, kun lento on yli 3 500 km, lähtö- tai määränpää on EU:n ulkopuolella ja viivästys alle 4 tuntia",
              "title": "Käteisarvo 300 €"
            },
            "middle": {
              "description": "Viivästys yli 3 tuntia, kun lento on yli 1 500 km EU:n sisällä tai 1 500–3 500 km EU:n ulkopuolella<br>Lentojen peruutus, kun lento on yli 1 500 km EU:n sisällä tai 1 500–3 500 km EU:n ulkopuolella, ja viivästys yli 3 tuntia",
              "title": "Käteisarvo 400 €"
            },
            "middleHalf": {
              "description": "Lentojen peruutus, kun lento on yli 1 500 km EU:n sisällä tai 1 500–3 500 km EU:n ulkopuolella, ja viivästys alle 3 tuntia",
              "title": "Käteisarvo 200 €"
            },
            "short": {
              "description": "Viivästys yli 3 tuntia, kun lento on alle 1 500 km<br>Lentojen peruutus, kun lento on alle 1 500 km ja viivästys yli 2 tuntia",
              "title": "Käteisarvo 250 €"
            },
            "shortHalf": {
              "description": "Lentojen peruutus, kun lento on alle 1 500 km ja viivästys alle 2 tuntia<br>Lentojen peruutus alle 7 päivää ennen lähtöä: koskee tapauksia, joissa uusi lähtöaika on yli (1) tunnin alkuperäistä lähtöaikaa aikaisemmin ja lento saapuu määränpäähän alle 2 tuntia ennen alkuperäistä saapumisaikaa",
              "title": "Käteisarvo 125 €"
            }
          }
        }
      }
    }
  },
  "NTServiceForms": {
    "fields": {
      "travelingWithAssistant": {
        "note": "Tarvitset mukaasi oman avustajan, jos tarvitset apua lääkkeiden ottamisessa, syömisessä, wc:ssä käymisessä, itsesi nostamisessa, happinaamarin laittamisessa kasvoille, tai et pysty viestimään turvallisuusasioista matkustamohenkilökunnan kanssa."
      }
    },
    "specialAssistanceForm": {
      "additionalInformation": {
        "note": "Huomaathan, että emme vastaa tämän lomakkeen kautta muihin kuin avustuspalveluun ja/tai terveydentilaan liittyviin yhteydenottoihin."
      },
      "consentToProcessingMedicalData": "Täyttämällä ja lähettämällä tämän lomakkeen annat meille suostumuksen käsitellä terveystietojasi palvelupyyntösi käsittelemiseksi ja toteuttamiseksi. Suostumus pätee tarvittaessa myös yhteistyökumppaneihimme.",
      "fileUploader": {
        "note": "Lisääthän tarvittavat liitetiedostot (ylle merkityn avustustarpeen syyn mukaan) ennen kuin lähetät pyyntösi."
      }
    }
  },
  "serviceForms": {
    "fields": {
      "state": {
        "required": "Osavaltio on pakollinen tieto"
      }
    }
  }
}
